// ===========================================
// BUSTED! BLACKJACK - PROTECTED ROUTE
// ===========================================

import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../stores';
import bustedLogo from '../assets/busted.png';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const location = useLocation();
  const { isAuthenticated, isLoading } = useAuthStore();

  // Show loading state while checking auth
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-900">
        <div className="text-center">
          <img src={bustedLogo} alt="BUSTED!" className="h-28 mx-auto animate-pulse" />
          <p className="text-gray-400">Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}

export default ProtectedRoute;
